<template>
    <v-autocomplete
            multiple
            v-model="searchModels"
            :items="itemsList"
            :chips="hasChips"
            hide-no-data
            :item-text="itemText || defaultItemTextPropertyName"
            item-value="value"
            :label="componentLabel"
            @change="valueChange"
            return-object
            color="orange lighten-2"
            item-color="orange lighten-2"
            clearable
            :attach="`#${searchName}`"
    >
        <template v-slot:append-outer>
            <div :id="searchName"></div>
        </template>
        <template v-slot:selection="data">
            <v-chip
                    :input-value="data.selected.id"
                    close
                    color="grey"
                    outlined
                    @click="data.selected"
                    @click:close="remove(data.item.id)"
            >
                <span class="d-inline-block text-truncate search-chip">{{ data.item[defaultItemTextPropertyName] }}</span>
            </v-chip>
        </template>
    </v-autocomplete>
</template>

<script>
    import BaseSimpleAutocomplete from '../../../general/mixins/BaseSimpleAutocomplete';

    export default {
        name: "BaseSearch",
        props:['resetFilter', 'attributeName'],
        mixins:[BaseSimpleAutocomplete],
        data() {
            return {
                params: {
                    categoryId: this.categoryId
                }
            }
        },
        computed: {
            filterName() {
                return this.$store.state.filters.general[this.searchName].systemName;
            }
        },
        methods: {

        },
        created() {
            this.checkInitial();
        },
        watch: {
            searchModels() {
                this.setChips()
            }
        }
    }
</script>

<style scoped>

</style>
